import { FaSpinner } from 'react-icons/fa';
import { getMyAccount, getTheme } from '../api/queries';
import { themeVariables } from '../helpers/helpers';
import AppState from '../store/appstate';

function ButtonPrimaryLarge(props) {
  const {
    id, children, onClick, disabled, pending, invert,
  } = props;

  const selectedAccount = AppState.useState((s) => s.selectedAccount);
  const myAccount = getMyAccount({
    artistaccountcode: selectedAccount,
  });
  const theme = getTheme({
    cataloguecode: myAccount?.data?.cataloguecode,
  });
  const { highlightColour } = themeVariables(theme);

  return (
    <button id={id} disabled={disabled} type="button" style={{ backgroundColor: !invert ? highlightColour : 'white', color: !invert ? 'white' : highlightColour }} className="disabled:opacity-25 disabled:pointer-events-none  font-semibold text-sm uppercase px-8 py-4 rounded-full outline-none focus:outline-none" onClick={onClick}>
      {children}
      {pending && <FaSpinner className="ml-3 text-white inline animate-spin" /> }
    </button>
  );
}

export default ButtonPrimaryLarge;
